import { PropsWithChildren } from 'react';
import { Tooltip } from '@mui/material';
import { MaterialIcon } from '../MaterialIcon';

export default function StatusDescription({ children }: PropsWithChildren) {
  return (
    <Tooltip title={children} arrow placement="top">
      <div>
        <MaterialIcon symbol="info" sx={{ display: 'block', transform: 'scale(0.7)' }} />
      </div>
    </Tooltip>
  );
}
